/**
 * Greeting args for a timezone, matching getDailyGreetingsTimeContext on the
 * client (UTC date, local hour) so the server preload and the live query use
 * identical args. Shared by the server loader and tests; no directive.
 */
export const TIMEZONE_COOKIE = 'imai-tz';

/** The timezone cookie's IANA name, or null when it is missing or malformed. */
export function readTimeZoneCookie(value: string | undefined): string | null {
  if (!value) return null;
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

export function greetingTimeContextInZone(
  now: Date,
  timeZone: string | null | undefined
): { date: string; hour: number } | null {
  if (!timeZone) return null;
  try {
    const hour = Number(
      new Intl.DateTimeFormat('en-US', {
        timeZone,
        hour: 'numeric',
        hourCycle: 'h23',
      }).format(now)
    );
    if (!Number.isInteger(hour) || hour < 0 || hour > 23) return null;
    return { date: now.toISOString().slice(0, 10), hour };
  } catch {
    return null;
  }
}
